"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isMediaElement(input) {
    return input instanceof HTMLImageElement
        || input instanceof HTMLVideoElement
        || input instanceof HTMLCanvasElement;
}
exports.isMediaElement = isMediaElement;
//# sourceMappingURL=isMediaElement.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/commons/isMediaElement.js
// module id = 261
// module chunks = 0